module.exports = __webpack_public_path__ + "static/media/4전쟁-1마을소개.28258c64.mp3";